<template>
  <div>
    <div class="col-md-12" style="padding-left: 5%; padding-right: 5%;">
      <div class="bg-plans-form mt-10">
        <h2>
          จัดการข้อมูลผู้ใช้
        </h2>
        <br />
        <b-button variant="success" @click="userActionModal()">+ เพิ่มผู้ใช้</b-button>
        <table ref="table_1" id="table_1" class="display" style="width:100%">
        </table>
      </div>
    </div>
    <b-modal id="userCreateForm" ref="userActionModal" centered no-enforce-focus size="lg" title="เพิ่มผู้ใช้งาน">
      <label class="mr-sm-2">ชื่อผู้ใช้</label>
      <b-form-input v-model="userCreateForm.username" size="sm"></b-form-input>

      <label class="mr-sm-2">รหัสผ่าน</label>
      <b-form-input v-model="userCreateForm.password" size="sm" type="password"></b-form-input>

      <label class="mr-sm-2">ชื่อ</label>
      <b-form-input v-model="userCreateForm.name" size="sm"></b-form-input>

      <label class="mr-sm-2 mt-3">สิทธิ์การใช้งาน</label>
      <b-form-select id="userCreatForm" class="plans-form-select-lg custom-select2" v-model="userCreateForm.permission"
        :options="formSetting.permission">
      </b-form-select>
      <template #modal-footer="{ cancel }">
        <b-button variant="primary" @click="confirmActionUser()">
          ยืนยีน
        </b-button>
        <b-button variant="danger" @click="cancel()">
          ยกเลิก
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import FetchService from "@/core/services/fetch.service";
import DataTable from 'datatables.net-bs4';
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import 'datatables.net-rowgroup-bs4';
import 'datatables.net-rowgroup-bs4/css/rowGroup.bootstrap4.css';
import 'datatables.net-buttons-bs4';
import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.css';
import $ from "jquery";
import moment from "moment";
import Swal from 'sweetalert2'
export default {
  data() {
    return {
      masterDataTable: {},
      dataTable: [],
      masterData: [],
      masterFormData: {
        companyData: []
      },
      userCreateForm: {
        username: "",
        password: "",
        name: "",
        permission: 3
      },
      userEditMode: 0,
      userIdSelect: "",
      formSetting: {
        permission: [
          {
            value: 1,
            text: "Administrator"
          },
          {
            value: 2,
            text: "Manager"
          },
          {
            value: 3,
            text: "Genaral"
          }
        ],
      },
    };
  },
  mounted() {
    setTimeout(() => {
      this.getDataTable()
    }, 100)
  },
  methods: {
    getDataTable() {
      if (this.masterDataTable?.destroy) {
        this.masterDataTable.destroy()
      }
      // this.masterData = [
      //  {
      //   _id: "1234", username: "tongb123", password: "******", name: "tong", permission: "Administrator",
      //  },
      //  {
      //   _id: "5678", username: "jnmro", password: "******", name: "jeno", permission: "Manager", 
      //  },
      //  {
      //   _id: "8910", username: "tkt", password: "******", name: "found", permission: "Genaral", 
      //  },
      // ]
      // this.pageInit()
      FetchService.get("/getuser", (response) => {
        if (response) {
          response = JSON.parse(response)
          this.masterData = response.allUser
          this.pageInit()
        }
      })
    },
    pageInit() {

      let that = this

      let arrTable = this.masterData.map((row, index) => {
        let permissionName = this.formSetting.permission.find(e => {
          return e.value == row.status
        })
        return [
          row?._id ? row._id : "",
          row?.username ? row.username : "",
          "******",
          row?.name ? row.name : "",
          permissionName?.text ? permissionName.text : "",
          `<button type="button" class="btn btn-warning mr-4 btn-edit" style="cursor: pointer" value="${row?._id}">แก้ไข</button> <button type="button" class="btn btn-danger mr-4 btn-del" style="cursor: pointer" value="${row?._id}">ลบ</button>`,
        ]
      })

      this.masterDataTable = new DataTable('#table_1', {
        data: arrTable,
        columns: [
          { title: 'ID' },
          { title: 'ชื่อผู้ใช้' },
          { title: 'รหัสผ่าน' },
          { title: 'ชื่อ' },
          { title: 'สิทธิ์การใช้งาน' },
          { title: 'ดำเนินการ' },
        ],
        dom: 'Bfrtip'
      });

      $('#table_1').on('click', '.btn-edit', (event) => {
        var data = event.currentTarget.value
        that.actionEdituser(data)
      });

      $('#table_1').on('click', '.btn-del', (event) => {
        var data = event.currentTarget.value
        that.actionDeluser(data)
      });

    },
    actionEdituser(userId) {
      this.userActionModal()

      const rowData = this.findMasterDataById(userId)
      this.userCreateForm = {
        _id: rowData._id,
        username: rowData.username,
        password: "",
        name: rowData.name,
        permission: rowData.status,
      }

      this.userEditMode = 1
      this.userIdSelect = userId

    },
    actionDeluser(userId) {
      this.userIdSelect = userId
      Swal.fire({
        title: 'ยืนยันการลบ ?',
        text: "คุณยืนยันการลบผู้ใช้งาน ใช่หรือไม่",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3699FE',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          this.delUser()
        }
      })
    },
    findMasterDataById(id) {
      return this.masterData.find(e => {
        return e._id === id
      })
    },
    userActionModal() {
      this.clearForm()
      this.$refs["userActionModal"].show()
    },
    adduser() {
      var raw = JSON.stringify({
        "username": this.userCreateForm.username,
        "password": this.userCreateForm.password,
        "name": this.userCreateForm.name,
        "status": this.userCreateForm.permission,
      });

      console.log(raw)

      FetchService.post("/createUser", raw, res => {
        Swal.fire(
          'สำเร็จ',
          'บันทึกข้อมูลแล้ว',
          'success'
        )
        this.getDataTable()
        this.$refs["userActionModal"].hide()
      })

    },
    edituser() {
      var raw = JSON.stringify({
        "_id": this.userCreateForm._id,
        "username": this.userCreateForm.username,
        "password": this.userCreateForm.password,
        "name": this.userCreateForm.name,
        "status": this.userCreateForm.permission,
      });

      FetchService.post(`/edituser/${this.userIdSelect}`, raw, res => {
        Swal.fire(
          'สำเร็จ',
          'แก้ไขข้อมูลแล้ว',
          'success'
        )
        this.getDataTable()
        this.$refs["userActionModal"].hide()
      })
    },
    delUser() {
      FetchService.get(`/deleteUser/${this.userIdSelect}`, res => {
        Swal.fire(
          'สำเร็จ',
          'ลบข้อมูลแล้ว',
          'success'
        )
        this.getDataTable()
        this.$refs["userActionModal"].hide()
      })
    },
    clearForm() {
      this.userCreateForm = {
        _id: "",
        username: "",
        password: "",
        name: "",
        permission: "",
      }
      this.userEditMode = 0
    },
    confirmActionUser() {
      if (this.userCreateForm.username == "" || this.userCreateForm.password == "" || this.userCreateForm.name == "" || this.userCreateForm.permission == "" || this.userCreateForm.permission == "") {
        Swal.fire(
          'มีข้อผิดพลาด',
          'กรุณาระบุข้อมูลผู้ใช้ให้ครบถ้วน',
          'error'
        )
      } else {
        if (this.userEditMode === 1) {
          Swal.fire({
            title: 'ยืนยันการแก้ไข ?',
            text: "คุณยืนยันการแก้ไขผู้ใช้งาน ใช่หรือไม่",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3699FE',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก'
          }).then((result) => {
            if (result.isConfirmed) {
              this.edituser()
            }
          })
        } else {
          Swal.fire({
            title: 'ยืนยันการบันทึก ?',
            text: "คุณยืนยันการบันทึกผู้ใช้งาน ใช่หรือไม่",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3699FE',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก'
          }).then((result) => {
            if (result.isConfirmed) {
              this.adduser()
            }
          })
        }
      }
    }
  }
}
</script>

<style>
.bg-plans-form {
  background-color: #FFFFFF;
  border-radius: 10px;
  padding: 20px;
  font-size: 1rem;
  font-weight: 500;
}

input,
label {
  margin: 0.5rem 0;
}

#table_1 table {
  border-collapse: separate;
  border-spacing: 0;
}

#table_1 th {
  border: solid 1px #DEDFE0;
  border-style: none solid solid none;
  padding: 10px;
}

.dataTables_wrapper .dataTable thead th {
  border-top: solid 1px #DEDFE0;
  background-color: #f9fafb;
}


#table_1 thead tr:first-child th:first-child {
  border-top-left-radius: 10px;
}

#table_1 thead tr:first-child th:last-child {
  border-top-right-radius: 10px;
}

#table_1 thead tr:first-child th {
  border-top-style: solid;
}

#table_1 thead tr th:first-child {
  border-left-style: solid;
}

#table_1 td {
  border: solid 1px #DEDFE0;
  border-style: none solid solid none;
  padding: 10px;
}

#table_1 tbody th {
  border-style: none solid solid solid;
}

#table_1 tbody tr:first-child td:first-child {
  /* border-top-left-radius: 10px; */
}

#table_1 tbody tr:first-child td:last-child {
  /* border-top-right-radius: 10px; */
}

#table_1 tbody tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}

#table_1 tbody tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

#table_1 tbody tr:first-child td {
  border-top-style: solid;
}

#table_1 tbody tr td:first-child {
  border-left-style: solid;
}

#table_1 tbody tr:first-child td:first-child.dataTables_empty {
  border-top-left-radius: 0px;
}

#table_1 tbody tr:first-child td:last-child.dataTables_empty {
  border-top-right-radius: 0px;
}

table.dataTable thead .sorting:before,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_desc:before {
  content: "" !important;
}

table.dataTable thead .sorting:after {
  content: "" !important;
}

table.dataTable thead .sorting_asc:after {
  content: "▲" !important;
  content: "▲" /"" !important;
}

table.dataTable thead .sorting_desc:after {
  content: "▼" !important;
  content: "▼" /"" !important;
}

table.dataTable tr.dtrg-group th {
  background-color: #f2f2f2;
  text-align: left;
}

#table_1 tbody tr:hover {
  background-color: #f5f5f5;
  /* สีที่คุณต้องการเมื่อ hover */
  cursor: pointer;
}

.dt-search {
  text-align: right;
  padding-bottom: 0.85rem;
}

.dt-search {
  text-align: right;
}
</style>